import React from 'react'
import BaseContainer from '../BaseContainer'
import BaseButton from '../BaseButton'
import styles from './alert.module.scss'
import { PushGADataLayer } from '../../utils/helpers'

export default function AlertBannerComp({ data }) {
  return (
    <BaseContainer className="h-0">
      <div className="p-3 lg:p-5 bg-ek-neutral-light rounded-lg grid grid-flow-col justify-between items-center -translate-y-full lg:-translate-y-1/2 relative z-10 h-[51px] lg:h-[66px]">
        <div className={`whitespace-nowrap text-ellipsis overflow-hidden pr-5 text-xs lg:text-sm text-ek-grey-600 font-light lg:font-normal ${styles.alert}`} dangerouslySetInnerHTML={{ __html: data?.content }}></div>
        {data?.link && <BaseButton title={data.link.title} href={data.link.href} target={data.link.target} type={data.link.type} size={data.link.size} btnClick={()=>{PushGADataLayer('Navigations','Top Navigation','Notice Clicks')}}></BaseButton>}
      </div>
    </BaseContainer>
  )
}
